import React from 'react';
import {ReactNode} from 'react';
import { Input } from 'antd';
import './input.scss';

type InputComponentParams = {
    value: string|number|undefined
    className?:string
    // onClickEvent:() => void
    onChangeEvent:(event: React.ChangeEvent<HTMLInputElement>) => void
    style?: {}
    status?:  "" | "error" | "warning" | undefined
    statusMsg?:string
    disabled?:boolean
    suffix?:ReactNode
    allowClear?:boolean
    placeholder?:string
    maxLength?:number
}

const InputComponent = ({
    value,
    className = '',
    // onClickEvent,
    onChangeEvent,
    style = {},
    status,
    statusMsg = '',
    disabled = false,
    suffix = '',
    allowClear,
    placeholder = '',
    maxLength
}:InputComponentParams) => {
    return (
        <>
            <Input
                className={className}
                value={value}
                // onClick={onClickEvent}
                onChange={onChangeEvent}
                style={style}
                status={status}
                disabled={disabled}
                suffix={suffix}
                allowClear={allowClear}
                placeholder={placeholder}
                maxLength={maxLength}
            />
            {statusMsg && <p className='mandatoryMsg'>{statusMsg}</p>}
        </>
    );
};

export default InputComponent;
